import { Info } from "lucide-react";

import { ResponsiveTooltip } from "@krea/shared/design-system/ResponsiveTooltip";

import type { IRepaymentPlanEntryData } from "./types";

/** Month 0 is not a repayment: its payment is the one-time setup fee. A
 * financed setup fee pays nothing then, so there is nothing to explain. */
export const isSetupFeeRow = (entry: IRepaymentPlanEntryData): boolean =>
  entry.month === 0 && Number(entry.payment) > 0;

// The shared package cannot reach customer-features' `Helper`, so this is the
// same info icon and tooltip built from the shared primitive it wraps.
export const PlanInfoNote = ({
  label,
  text,
}: {
  label: string;
  text: string;
}) => (
  <ResponsiveTooltip
    className="max-w-[16rem]"
    trigger={
      <button
        type="button"
        aria-label={label}
        className="flex shrink-0 cursor-help items-center text-gray-500 hover:text-gray-700 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-1"
      >
        <Info className="size-3.5" />
      </button>
    }
  >
    <p className="text-helper">{text}</p>
  </ResponsiveTooltip>
);
